import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PhoneService } from '../services';
import { PhoneList, Variant } from '../models';

@Component({
  selector: 'app-variant-details',
  templateUrl: './variant-details.component.html',
  styleUrls: ['./variant-details.component.scss']
})
export class VariantDetailsComponent implements OnInit, OnDestroy {
  private sub;
  @Input() variant: Variant;
  suggestedVariants: Variant[] = [];

  constructor(private route: ActivatedRoute, private phoneService: PhoneService) { }

  ngOnInit() { 
    this.suggestedVariants = this.variant.getSuggestedVariants();
    // FIXME remove the highlighted phones and use only getSuggestedVariants
    this.sub = this.phoneService.obs.phoneList
      .subscribe((phoneList: PhoneList) => {
        const highlights: Variant[] = <Array<Variant>>Array.from(phoneList.highlights.values());
        this.suggestedVariants = this.suggestedVariants.concat(highlights);
      });
  }

  ngOnDestroy() { 
    this.sub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/fonzi-module/variant-details/variant-details.component.ts